export default __webpack_public_path__ + "static/media/moon.afafe5a0.svg";